export default __webpack_public_path__ + "static/media/services-icon1.536eeac3.png";